// extracted by mini-css-extract-plugin
export default {"main":"MainContent_main__uS7HD","inner":"MainContent_inner__qII14"};